export var HarmonySessionKey = 'wdPreviousSession';
export var HarmonySessionSourceKey = 'wdPreviousSessionSrc';
//# sourceMappingURL=HarmonySessionSource.js.map